import React, { useEffect, useState } from "react";
import { useLazyGetAcademyHomeDataQuery } from "../../store/api/academyApi";
import Modal from "../common/modals";
import {
  AcademyComicsCloseButton,
  AcademyComicsNavigateButton,
} from "../../icons/academy-icons";
import { useAppDispatch, useAppSelector } from "../../hooks/store-hooks";
import { openModal } from "../../store/slices/modalSlice";
import { MODAL_NAME } from "../../constants";
import BecomeMember from "../common/membership";
import LockedOverlay from "../common/locked_content";

interface Comic {
  comic_id: string;
  description: string;
  heading: string;
  thumbnail: string;
  is_subscribed?: boolean;
  price?: number;
}

function ComicsComponent() {
  const [triggerGetAcademyAllTabData] = useLazyGetAcademyHomeDataQuery();
  const [comicData, setComicData] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedComic, setSelectedComic] = useState<number>(0);
  const dispatch = useAppDispatch();
  const { modalName: globalpModal } = useAppSelector((state) => state.modal);

  const fetchComicData = async () => {
    const resp = await triggerGetAcademyAllTabData({ type: "comic" }).unwrap();
    setComicData(resp.data);
  };

  useEffect(() => {
    fetchComicData();
  }, []);

  const handleClick = (index: number) => {
    if (comicData?.comics_list?.[index].is_subscribed === false) {
      dispatch(openModal({ modalName: MODAL_NAME.BECOME_MEMBER }));
      return;
    }
    setSelectedComic(index);
    setIsModalOpen(true);
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Comics</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 2xl:grid-cols-5 gap-6 w-full">
          {comicData?.comics_list?.map((comic: Comic, index: number) => (
            <div
              key={index}
              className="bg-white h-[23rem] rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              onClick={() => handleClick(index)}
            >
              <div className="relative h-full w-full">
                <img
                  src={comic.thumbnail}
                  alt={comic.heading}
                  className="w-full object-cover inset-0 h-full"
                ></img>
                {comic.is_subscribed ? null : (
                  <LockedOverlay blur={true} price={comic.price || 0} />
                )}
              </div>
            </div>
          ))}
          {
            <Modal
              isOpen={isModalOpen}
              customClass="!bg-transparent md:!w-fit !max-w-fit md:!max-w-fit md:!h-screen !max-h-fit !shadow-none  md:!p-0 !p-0 !overflow-visible"
            >
              <div className=" w-fit !bg-transparent flex">
                <div className=" w-fit">
                  <div
                    className="fixed top-[50%] left-[50%] -translate-x-[320px] -translate-y-[50%] left-4"
                    onClick={() =>
                      setSelectedComic(
                        (selectedComic - 1 + comicData?.comics_list.length) %
                          comicData?.comics_list.length,
                      )
                    }
                  >
                    <AcademyComicsNavigateButton />
                  </div>
                  <div className="w-fit flex flex-col">
                    <div className="bg-white m-auto !w-[460px]">
                      <div className="w-full">
                        <img
                          src={
                            comicData?.comics_list?.[selectedComic]?.thumbnail
                          }
                          alt={comicData?.comics_list?.[selectedComic]?.heading}
                          className="w-full px-4 pt-4"
                        />
                      </div>
                      <div className="px-4 pb-4">
                        <p className="text-3xl font-bold">
                          {comicData?.comics_list?.[selectedComic]?.heading}
                        </p>
                        <p className="text-[#404040]">
                          {comicData?.comics_list?.[selectedComic]?.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="fixed top-[50%] right-[50%] translate-x-[320px] -translate-y-[50%] right-4"
                    onClick={() =>
                      setSelectedComic(
                        (selectedComic + 1) % comicData?.comics_list.length,
                      )
                    }
                  >
                    <AcademyComicsNavigateButton rotate={180} />
                  </div>
                </div>
              </div>
              <div
                className="fixed top-8 right-8"
                onClick={() => setIsModalOpen(false)}
              >
                <AcademyComicsCloseButton width={16} />
              </div>
            </Modal>
          }
          {globalpModal === MODAL_NAME.BECOME_MEMBER && <BecomeMember />}
        </div>
      </div>
    </div>
  );
}

export default ComicsComponent;
